require('./icons');
import WhitelabelPlugin from './plugins/Whitelabel'
import RoutingPlugin from './plugins/Routing'
import App from './pages/App.vue'
import { initializeGrowthBook } from "./growthbook";
import Vue from 'vue'
import router from './routes';
import {i18n} from './i18n'
import VueTheMask from 'vue-the-mask'
import Axios from 'axios'
import UserStore from './stores/user'
import Whitelabel from './stores/whitelabel'
import Stripe from './stores/stripe'
import breakpoints from "./stores/breakpoints"
import CheckoutReview from "./stores/checkoutReview";
import googleApi from './stores/googleApi';

import VueHead from "vue-head"
import VueGtag from "vue-gtag";
import VCalendar from 'v-calendar';

import { AppVersion } from './version/version';
import { setCookie, getCookie, setLocaleCookie } from './plugins/cookies';

import * as Sentry from "@sentry/vue";


Vue.use(VueHead)
Vue.use(VCalendar)
Vue.use(WhitelabelPlugin)
Vue.use(RoutingPlugin)
Vue.use(VueTheMask)
Vue.prototype.$axios = Axios
Vue.prototype.$getCookie = getCookie
Vue.prototype.$setCookie = setCookie
Vue.prototype.$setLocaleCookie = setLocaleCookie
Vue.prototype.$stripe = Stripe

const appVersion = new AppVersion()
const app = new Vue({
    el: '#app',
    router,
    i18n,
    render: h => h(App),
    data: {
        currentRoute: window.location.pathname,
        user: UserStore,
        whitelabel: Whitelabel,
        stripe: Stripe,
        checkoutReview: CheckoutReview,
        googleApi: googleApi,
    },

    methods:{
        initWhitelabel: function() {
            this.$axios.get('/sanctum/csrf-cookie').catch(console.error);
            this.$axios.get('api/init-whitelabel')
                .then(response => {
                    this.whitelabel.handleResponse(response, this.user, this);
                    this.handleGoogleAnalytics()

                    appVersion.cleanUpCache()

                    let routeName = this.$route.name
                    if (['login', 'register', 'password_forget', 'pasword_reset', 'password_reset'].includes(this.$route.name)) {
                        if (this.user.isLoggedIn()) {
                            routeName = 'cdb-dashboard'
                        }
                    } else {
                        if (!this.user.isLoggedIn() && this.whitelabel.state.settings.is_b2b) {
                            routeName = 'login'
                        }
                    }

                    this.$goTo(routeName, this.$route.params, this.$route.query)
                })
                .catch(error => {
                    //todo handle call if init wont work
                    console.error((error))
                });
        },

        handleUserLogin: function(checkMailVerified = true) {
            if(!this.user.isLoggedIn()){
                this.$goTo('login')
            } else if(checkMailVerified) {
                if(!this.user.hasVerifiedMail()){
                    this.$router.push({name:'account_not_verified'})
                }
            }
        },
        handleGoogleAnalytics() {
            const loggingActive = process.env.MIX_VUE_APP_ACTIVATE_GOOGLE_ANALYTICS

            if(this.whitelabel.state.settings.tracking_property1){
                let options = {
                    config: {id: this.whitelabel.state.settings.tracking_property1}
                }

                if (loggingActive && this.whitelabel.state.settings.tracking_property1 !== '') {
                    if(this.whitelabel.state.settings.tracking_property2 !== ''){
                        options.includes = [
                            { id : this.whitelabel.state.settings.tracking_property2}
                        ]
                    }

                    Vue.use(VueGtag, options)
                }
            }
        }
    },

    computed: {
        breakpoints: () => breakpoints.screen
    },

    created(){
        this.initWhitelabel()
    },
})


window.addEventListener('popstate', () => {
    app.currentRoute = window.location.pathname
})

Sentry.init({
    Vue,
    dsn: process.env.MIX_VUE_APP_SENTRY_LARAVEL_DSN,
    // This sets the sample rate to be 0%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 0,
  });

// Needs to be called after the app is created
initializeGrowthBook();
